import { useState, type ReactElement } from 'react';
import { Box } from '@common';
import * as Base from '@base';
import { service } from '../service';
import styles from '../style.module.less';
import { Highlighter } from '../../component';
import { Character } from './character';
import type { ShotEyesStarProps } from './types';

export function ShotEyesStarInputMode(props: ShotEyesStarProps): ReactElement {
  const [value, setValue] = useState<number>(props.value ?? 0);
  const onChange = (count: number): void => {
    if (props?.option?.length === 0) {
      setValue(count);
      props.onPropsChange?.({ value: count });
      return;
    }
    // 选中的数量
    setValue(count);
    props.onPropsChange?.({ value: props.option[count - 1]?.value ?? 0 });
  };
  return (
    <Box className={styles.inputBox} style={{ marginLeft: service.getIndent(props.path, 0.7) }}>
      <Box className={styles.subject}>
        <Highlighter
          title={props.title}
          require={props.validator === 'required'}
          keyword={props.keyword}
          className={styles.title}
        />
      </Box>
      <Box className={styles.input}>
        <Base.Rate
          defaultValue={props.value ?? 0}
          value={value}
          className={styles.rate}
          count={props.option?.length ?? 5}
          onChange={value => onChange(value)}
          character={rate => (
            <Character
              index={rate.index}
              selectStyle={props.selectStyle}
              option={props.option}
              value={value}
            />
          )}
        />
      </Box>
    </Box>
  );
}
